import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.highlightCurrentChat()

    // Re-highlight after Turbo navigations
    document.addEventListener('turbo:load', () => this.highlightCurrentChat())
    document.addEventListener('turbo:frame-load', () => this.highlightCurrentChat())
  }

  highlightCurrentChat() {
    const match = window.location.pathname.match(/\/chats\/(\d+)/)
    if (match) {
      this.highlightChat(match[1])
    }
  }

  selectChat(event) {
    // Get the chat ID from the clicked element
    const chatItem = event.currentTarget.closest('[data-chat-id]')
    if (chatItem) {
      this.highlightChat(chatItem.dataset.chatId)
    }
  }

  highlightChat(chatId) {
    // Remove active class from all items
    this.element.querySelectorAll('[data-chat-id]').forEach(el => {
      el.classList.remove('chat-active')
    })

    // Add active class to selected item
    const selectedChat = this.element.querySelector(`#chat_item_${chatId}`)
    if (selectedChat) {
      selectedChat.classList.add('chat-active')
    }
  }
}
